import { makeStyles } from '@mui/styles';

import Colors from 'configs/Colors';

const useStyles = makeStyles(() => ({
  listImageItemAward: {
    cursor: 'pointer',
    marginTop: 16,
    display: 'flex',
    width: '100%',
  },
  wrapYearAward: {
    display: 'flex',
    width: '15%',
    marginBottom: 3,
  },
  wrapDescriptionAndIcon: {
    display: 'flex',
    width: '85%',
    justifyContent: 'space-between',
  },
  textYearAward: {
    marginLeft: 24,
    color: Colors.Grey8,
    width: 38,
  },
  wrapDescriptionAndImage: {
    display: 'block',
    width: '85%',
    color: Colors.Grey8,
    wordWrap: 'break-word',
  },
  editIcon: {
    '&.MuiIcon-root': {
      color: Colors.Black,
      marginRight: 8,
    },
  },
  wrapImagItemAward: {
    display: 'flex',
    width: '90%',
    marginTop: 8,
  },
  imagItemAward: {
    width: 45,
    height: 45,
    objectFit: 'cover',
    display: 'block',
    marginRight: 8,
    borderRadius: 0,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  dividerStyle: {
    '&.MuiDivider-root': {
      color: Colors.Grey3,
      marginTop: 16,
      width: '100%',
    },
  },
  iconVisibility: {
    '&.MuiSvgIcon-root': {
      marginTop: -1,
    },
  },
  iconPdf: {
    width: 45,
    height: 45,
    marginLeft: -2,
    marginRight: 8,
  },
}));

export default useStyles;
